import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-left-pagination-arrow';
export var ID = 'icon-left-pagination-arrow';
/* eslint-disable max-len */

export var SVGLeftPaginationArrow = function SVGLeftPaginationArrow() {
  return React.createElement("symbol", {
    id: ID,
    width: "8px",
    height: "13px",
    viewBox: "0 0 8 13"
  }, React.createElement("path", {
    d: "M.135 6.532C.045 6.465 0 6.352 0 6.262c0-.112.045-.224.135-.29L5.97.134C6.06.045 6.15 0 6.262 0c.09 0 .202.045.292.135l.606.628c.09.068.135.18.135.27 0 .112-.045.224-.135.29l-4.916 4.94 4.916 4.915c.09.09.135.18.135.292 0 .112-.045.202-.135.292l-.606.606c-.09.09-.202.134-.292.134-.112 0-.202-.044-.292-.134L.135 6.532z",
    fillRule: "evenodd"
  }));
};
/* eslint-disable max-len */

var LeftPaginationArrow = function LeftPaginationArrow(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGLeftPaginationArrow
  });
};

LeftPaginationArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default LeftPaginationArrow;